










































































































































































































































































































































import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  ref,
  useContext,
  useRoute,
  useRouter,
  useStore,
  watch,
} from '@nuxtjs/composition-api'

import { debounce } from 'throttle-debounce'

import BrandMediaSidebarItem from '../components/BrandMedia/UI/BrandMediaSidebarItem.vue'
import BrandMediaTag from '../components/BrandMedia/UI/BrandMediaTag.vue'
import BrandMediaCard from '../components/BrandMedia/Cards/BrandMediaCard.vue'
import SectionResolutForm from './SectionResolutForm.vue'

import { likeArticle } from '@/api/bitrix/brand-media/like/likeApi'
import { dislikeArticle } from '@/api/bitrix/brand-media/dislike/dislikeApi'
import { neutralArticle } from '@/api/bitrix/brand-media/neutral/neutralApi'
import { viewArticle } from '@/api/bitrix/brand-media/article/articleViews'
import { getLeader } from '@/api/bitrix/brand-media/leader/leaderApi'
import { getArticleShort } from '@/api/bitrix/brand-media/article/short'
import TeleportV2 from '@/components/TeleportV2.vue'
import { Logger } from '@/composition/Logger'

export default defineComponent({
  components: {
    TeleportV2,
    BrandMediaCard,
    BrandMediaTag,
    BrandMediaSidebarItem,
    SectionResolutForm,
  },

  props: {
    article: { type: Object, required: true },
    tgURL: { type: String, default: '' },
    vkURL: { type: String, default: '' },
  },

  setup(props) {
    const store = useStore()
    const ctx = useContext()
    const route = useRoute()
    const router = useRouter()

    const articlePictureRef = ref<{ $el: HTMLDivElement } | null>(null)

    // ===== helpers (SEO) =====
    const stripHtml = (html?: string) =>
      !html
        ? ''
        : String(html)
            .replace(/<[^>]*>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()

    const absolutize = (url?: string | null, base?: string) => {
      if (!url) return ''
      try {
        new URL(url)
        return url
      } catch {
        const b = (base || '').replace(/\/$/, '')
        const sep = url.startsWith('/') ? '' : '/'
        return b ? `${b}${sep}${url}` : url
      }
    }

    // ===== SEO из article.markup =====
    const BASE =
      (process.env.BASE_URL || '').replace(/\/$/, '') || 'https://rgs.ru'
    const defaultSeo = ctx.app.$defaultSeo || {}

    const markup = computed(() => (props.article as any)?.markup || {})

    const headTitle = computed<string>(
      () =>
        markup.value.title?.trim?.() ||
        (props.article as any)?.title?.trim?.() ||
        defaultSeo.title ||
        ''
    )

    const headDescription = computed<string>(() => {
      const raw =
        markup.value.description ||
        (props.article as any)?.description ||
        defaultSeo.description ||
        ''
      return stripHtml(raw)
    })

    const formatDateDMY = (d: unknown): string => {
      if (!d) return ''
      const s = String(d).trim()

      const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})/)
      if (m) return `${m[1]}.${m[2]}.${m[3]}`

      const parsed = new Date(s)
      if (Number.isNaN(parsed.getTime())) return s

      const dd = String(parsed.getDate()).padStart(2, '0')
      const mm = String(parsed.getMonth() + 1).padStart(2, '0')
      return `${dd}.${mm}.${parsed.getFullYear()}`
    }

    const articleDate = computed<string>(() =>
      formatDateDMY((props.article as any)?.date)
    )

    const ogType = computed<string>(() => markup.value.type || 'article')
    const ogImage = computed<string>(() =>
      absolutize(markup.value.image || (props.article as any)?.img, BASE)
    )
    const ogUrl = computed<string>(() =>
      absolutize(route.value.fullPath || '/', BASE)
    )
    const siteName = computed<string>(
      () => ctx.app.$pagesList?.siteName || defaultSeo.siteName || ''
    )
    const robotsName = 'robots'
    const robotsContent = 'index, follow'
    const canonicalHref = computed<string>(() => ogUrl.value)

    // ===== разбивка контента для вставки SectionResolutForm =====
    const contentParts = computed(() => {
      const content: string = (props.article as any).content || ''
      const forms: Array<{ index: number; props: Record<string, any> }> =
        (props.article as any).resolutForms || []

      type Part =
        | { type: 'html'; html: string }
        | {
            type: 'resolut'
            formProps: Record<string, any>
            additionalProps: Record<string, any>
          }

      const parts: Part[] = []
      const regex = /<div\b[^>]*\bid="resolut-form-slot-(\d+)"[^>]*><\/div>/gi
      let match: RegExpExecArray | null
      let lastIndex = 0

      while ((match = regex.exec(content)) !== null) {
        const slotIndex = parseInt(match[1], 10)
        parts.push({
          type: 'html',
          html: content.slice(lastIndex, match.index),
        })
        const form = forms.find((f) => f.index === slotIndex)
        if (form) {
          parts.push({
            type: 'resolut',
            formProps: form.props,
            additionalProps: form.additionalProps || {},
          })
        }
        lastIndex = match.index + match[0].length
      }

      parts.push({ type: 'html', html: content.slice(lastIndex) })
      return parts
    })
    // ===== остальная логика компонента =====

    const navItems = computed(() => {
      return props.article?.nav || []
    })

    const activeLink = ref(navItems.value[0]?.id || '')

    const showMobileNav = ref<boolean>(false)

    const handleMobileNavScroll = (link: string) => {
      try {
        const item = document.querySelector(`.article-mobile-nav-item__${link}`)
        item?.scrollIntoView({ behavior: 'smooth', inline: 'start' })
      } catch (e) {
        console.log(e)
      }
    }

    const onNav = debounce(
      100,
      false,
      (link: string, triggerScroll: boolean) => {
        activeLink.value = link
        if (triggerScroll) {
          handleMobileNavScroll(link)
        }
      }
    )

    const handleMobileNav = () => {
      if (!articlePictureRef.value) {
        return
      }

      const rect = articlePictureRef.value.$el.getBoundingClientRect()

      showMobileNav.value = rect.bottom < 0
    }

    const handleActiveNav = () => {
      const headings = [...document.querySelectorAll('.article h2')].filter(
        (el) => el.id
      )

      if (!headings.length) {
        return
      }

      const offset = 100

      let active = headings[0]

      for (const heading of headings) {
        if (heading.getBoundingClientRect().top <= offset) {
          active = heading
        } else {
          break
        }
      }

      if (active) {
        onNav(active.id, true)
      }
    }

    const onScroll = () => {
      handleMobileNav()
      handleActiveNav()
    }

    onMounted(() => {
      window.addEventListener('scroll', onScroll, { passive: true })
    })

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onScroll, { passive: true })
    })

    const likes = ref(0)
    const dislikes = ref(0)
    const neutralCount = ref(0)
    const views = ref(0)
    const reaction = ref<'like' | 'dislike' | 'neutral' | null>(null)
    const reactionError = ref(false)
    const isShare = ref(false)
    const closeShare = () => {
      isShare.value = false
    }
    const recommendations = ref<any[]>(props.article?.recommendations || [])

    const fetchRecommendations = async () => {
      const response = await getLeader(
        ctx,
        (props.article as any).code,
        3,
        (props.article as any).id
      )
      const data = response.data?.data
      recommendations.value = (data || []).map((a: any) => ({
        ...a,
        headingImg: sectionImgByCode.value[a.code] ?? null,
      }))
    }

    const handlerAuthorClick = () => {
      const id = (props.article as any)?.author?.id
      if (id != null) router.push(`/prosto/author/${id}`)
    }

    const sectionImgByCode = computed<Record<string, string | null>>(
      () => store.getters['sections/IMG_BY_CODE']
    )

    const titleByCode = computed(() =>
      store.getters['sections/TITLE_BY_CODE'](
        (props.article as any)?.code || ''
      )
    )

    const imgByCode = computed(() =>
      store.getters['sections/IMG_FOR_CODE']((props.article as any)?.code || '')
    )

    const fetchViews = async () => {
      const response = await viewArticle(ctx, (props.article as any).id)
      views.value = response.data.data.views
    }

    const fetchLikes = async () => {
      const code = route.value.path.split('/').pop()
      const response = await getArticleShort(ctx, code)
      likes.value = response.likes
      dislikes.value = response.dislikes
      neutralCount.value = response.neutral
    }

    const sendReaction = async (
      type: 'like' | 'dislike' | 'neutral',
      apiFn: typeof likeArticle,
      counter: typeof likes
    ) => {
      if (reaction.value !== null) return

      reactionError.value = false
      reaction.value = type
      try {
        await apiFn(ctx, (props.article as any).id)
        counter.value++
      } catch (e) {
        reaction.value = null
        reactionError.value = true
        Logger.error(`${type} reaction error:`, e)
      }
    }

    const like = () => sendReaction('like', likeArticle, likes)
    const neutral = () => sendReaction('neutral', neutralArticle, neutralCount)
    const dislike = () => sendReaction('dislike', dislikeArticle, dislikes)

    onMounted(() => {
      store.commit('settings/SET_IS_PROSTO_ARTICLE', true)
      // Эти данные должны загружаться при заходе на страницу, кеширование недопустимо
      if (props.article) {
        fetchLikes()
        fetchViews()
        // Получаем т.к. содержит те же лайки и просмотры
        fetchRecommendations()
      }
    })

    onUnmounted(() => {
      store.commit('settings/SET_IS_PROSTO_ARTICLE', false)
    })

    const copyLink = async () => {
      const url =
        typeof window !== 'undefined'
          ? window.location.origin + (route.value.fullPath || '/')
          : ogUrl.value
      if (!url) return

      try {
        if (navigator?.clipboard?.writeText && window.isSecureContext) {
          await navigator.clipboard.writeText(url)
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = url
          textarea.setAttribute('readonly', '')
          textarea.style.position = 'fixed'
          textarea.style.top = '-9999px'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
      } catch (e) {
        Logger.error('copyLink error:', e)
      } finally {
        closeShare()
      }
    }

    return {
      showMobileNav,
      articlePictureRef,
      titleByCode,
      imgByCode,
      like,
      likes,
      dislike,
      neutral,
      views,
      route,
      ogUrl,
      articleDate,
      copyLink,
      closeShare,
      handlerAuthorClick,
      reaction,
      reactionError,
      dislikes,
      neutralCount,
      isShare,
      recommendations,
      contentParts,
      navItems,
      activeLink,
      onNav,
    }
  },
})
